/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import ModuloList from './ModuloList';
import {bindActionCreators} from 'redux';
import * as moduloActions from '../../actions/moduloActions';
import toastr from 'toastr';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';

import ManageList from '../common/ManageList';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {getMargenes} from '../../util/';
import * as tablasActions from '../../actions/tablasActions';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import * as cursoActions from '../../actions/cursoActions';
import {genericFormattedForDropdown} from '../../selectors/selectors';

class ManageModuloList extends ManageList  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            strings:[],
            showActivos:true,
            filtrosCombo:{
                    curso:"0",
                    opcional:true
            },
            permisos:{}
		};
	}

	componentDidMount(){
            let id=this.props.id;
            if(id && id>0 ){
                this.state.filtrosCombo.curso = id;   
            }
        
            usuarioActual(this, "Modulo",true).then( (usuario)=>{
            window.scrollTo(0, 0);
            this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
                let tabla={
                    "nombre":"idsContenidos",
                    "rows":[]
                };
                
                this.props.cursoActions.getCursoCombo( usuario).then( ()=>{

                })
                    .catch(error=>{
                      toastr.error(error);
                });    
            
            
                this.props.tablasActions.update(tabla);
                   if(this.props.user!=null)
                      this.inicializa();
               }).catch(error=>{
                    toastr.error(error);
            }); 
        
            
    
	}
    
    goBack=()=>{
         this.props.history.goBack();
    }
  
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment  style={margenes}>
                  
                <ModuloList
                    strings={this.props.strings}
                    modulo={this.props.listado.content}
                    activePage={this.props.listado.paginaActual+1}
                    handleSelectPagination={this.handleSelectPagination}
                    totalPages={this.props.listado.totalPages}
                    handleChange= {this.handleChangeFiltro}
                    filtro={this.state.filtro}
                    onFiltrarInformacion={this.onFiltrarInformacion}
                    filtroActivo={this.props.listado.filtroActivo}
                    filtroActual={this.props.listado.filtroActual}
                    onDesactivarFiltro={this.onDesactivarFiltro}
                    confirmarBorrado={this.confirmarBorrado}
                    onShowModalBorrar={this.onShowModalBorrar}
                    onShowModalActivar={this.onShowModalActivar}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleChangeFiltro= {this.handleChangeFiltro}
                    handleChangeActivos={this.handleChangeActivos}
                    showActivos={this.props.listado.showActivos}
                    color={this.props.color}
				    form={this.props.form}
                    permisos={this.state.permisos}
                    cursosCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    handleChangeFiltroCombo= {this.handleChangeFiltroCombo}
                    filtrosCombo={this.props.listado.filtrosCombo}
                    errors={this.state.errors}
                    goBack={this.goBack}
                    

                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.borrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente?"}
                    titulo={this.state.strings?this.state.strings["Modulo"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalActivar}
                    closeModal={this.oncloseModal}
                    borrar={this.activar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea cambiar el esatus del registro?"}
                    titulo={this.state.strings?this.state.strings["Modulo"]:""}
                 />

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
     //let id = ownProps.match.params.id;
    
    return {
            listado:state.modulo,
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            ajaxCallInProgress:state.ajaxCallInProgress,
            color:state.color,
            permisos:state.permisos,
            form:state.form,
            strings:state.strings,
            user:state.user,
            cursoCombo:state.cursoCombo,
            idioma:state.idioma
    }

}

function mapDispatchToProps(dispatch){

	return { 
            menuActions:bindActionCreators(menuActions, dispatch),
            tablasActions: bindActionCreators(tablasActions, dispatch),
            userActions: bindActionCreators(userActions, dispatch),
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            listadoActions: bindActionCreators(moduloActions, dispatch),
            cursoActions: bindActionCreators(cursoActions, dispatch),
            load:bindActionCreators(moduloActions.getModuloList, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageModuloList));